import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/foursquare': {
    width: 368,
    height: 512,
    paths: [
      {
        d: 'M323.1 3c40 0 50.7 22.8 42.2 65.2l-48.6 243c-3.7 14.5-9.2 39.7-44.3 39.7h-83.4c-3.4 0-3.7-0.3-6.8 3.1 0 0-2.2 2.5-131.1 151.9-10.1 11.7-26.7 9.6-32.9 7.1-6.1-2.4-18.2-9.8-18.2-30.1v-433.8c0-17.8 12.4-46.1 49.9-46.1h273.2zM306.8 76.8c2.1-9.8-5.3-17.5-13.5-17.5h-219c-9.8 0-16.6 8.9-16.6 16.6v338.8c0 0.9 0.9 1.2 1.8 0.3 80.6-96.9 89.5-108.3 89.5-108.3 9.3-10.8 13-12.6 26.5-12.6h73.5c10.1 0 16-8.6 16.9-13.5 0.9-5 9.6-49.9 11.4-58.8 1.8-9-6.5-18.2-14.8-18.2h-90.4c-12 0-20.6-8.6-20.6-20.6v-13c0-12 8.6-20.3 20.6-20.3h106.4c7.4 0 15.7-6.7 16.9-13.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/foursquare.js
// module id = 839
// module chunks = 0